import React from 'react';
import { Box, Typography, Container, TextField, Button } from '@mui/material';

const ContactSection: React.FC<{ contact: any, contactError: string, contactSuccess: boolean, handleContactChange: any, handleContactSubmit: any }> = ({ contact, contactError, contactSuccess, handleContactChange, handleContactSubmit }) => (
  <Box sx={{ py: 8 }} id="contact">
    <Container maxWidth="lg">
      <Typography variant="h3" color="primary" fontWeight={700} gutterBottom>
        Contact Us
      </Typography>
      <Box component="form" onSubmit={handleContactSubmit} sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={contact.name}
          onChange={handleContactChange}
          sx={{ mb: 2 }}
          required
        />
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={contact.email}
          onChange={handleContactChange}
          sx={{ mb: 2 }}
          required
        />
        <TextField
          fullWidth
          label="Message"
          name="message"
          value={contact.message}
          onChange={handleContactChange}
          sx={{ mb: 2 }}
          multiline
          minRows={4}
          required
        />
        {contactError && <Typography color="error" sx={{ mb: 2 }}>{contactError}</Typography>}
        {contactSuccess && <Typography color="success.main" sx={{ mb: 2 }}>Message sent successfully!</Typography>}
        <Button type="submit" variant="contained" color="primary" size="large">
          Send
        </Button>
      </Box>
    </Container>
  </Box>
);

export default ContactSection; 